module.exports = __webpack_public_path__ + "static/media/1.97f280f6.jpg";